import { Component, Inject, Input, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { AdminService } from "../admin.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { CommonServices } from "src/app/common.services";
import { formatDate } from "@angular/common";

@Component({
  selector: "app-admin-retail-edit-trips",
  templateUrl: "./admin-retail-edit-trips.component.html",
  styleUrls: ["./admin-retail-edit-trips.component.css"],
})
export class AdminRetailEditTripsComponent implements OnInit {
  editTripform!: FormGroup;
  tripArray: any;
  selectCatgValue: any;
  searchEmployeeName: any = -1;
  employeeName: any = [];
  perPage: any = 10;
  employeeStartPage: any = 1;
  vehiclelists: any;
  token: any;
  item: any;
  fetch_page: any = 0;
  currentPage: any = 0;
  startPage: any = 1;
  searchtripID: any = -1;
  vehiclenoArray: any;
  work_order_msg: any;
  selectedDriverId: any;
  dateFormat = "yyyy-MM-dd";
  language = "en";
  loading: boolean = false;
  @Input() min: any;
  minDate = new Date();
  @Input() max: any;
  maxDate = new Date();
  truckArray: any[] = [];
  searchQuery: any = -1;
  paginationTrips: boolean = true;
  tripsArray: any;
  tripType: any = "-1";
  last_page: any = 1;
  document_array: any = [];

  constructor(
    private matdialogref: MatDialogRef<AdminRetailEditTripsComponent>,
    private formBuilder: FormBuilder,
    private services: AdminService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private commonServices: CommonServices
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.employeeGet(this.searchEmployeeName);
    this.trips(this.searchtripID);
    this.editTripform = this.formBuilder.group({
      username: ["", Validators.required],
      work_order: [""],
      trip_id: [""],
      truck_ownerName: [""],
      truck_ownerNumber: [""],
      truck_number: [""],
      driver_number: [""],
      driver_name: [""],
      unloading_point: [""],
      user_id: [""],
      work_date: [""],
      workorder_id: [""],
      mobile: [""],
      driver_ref_id: [""],
      total_tons: [""],
      truckowner_id: [""],
      remaining_tons: ["", Validators.compose([Validators.required])],
      trip_booking_date: [""],
      truck_id: ["", Validators.compose([Validators.required])],
      driver_id: ["", Validators.compose([Validators.required])],
      driver_no: [""],
      price: [""],
    });

    this.editTripform.patchValue(this.data);
    this.editTripform.patchValue({
      username: this.data.userInfo[0]?.username,
      trip_id: this.data.trip_id,
      mobile: this.data.userInfo[0]?.mobile,
      user_id: this.data.userInfo[0]?.user_id,
      trip_booking_date: this.data.pickup_date,
      truck_id: this.data.truckInfo?.truck_id,
      truck_ownerName: this.data.truckownerInfo[0]?.username,
      truck_ownerNumber: this.data.truckownerInfo[0]?.mobile,
      truck_number: this.data.truckInfo[0]?.truck_number,
      driver_id: this.data.driverInfo[0]?.username,
      driver_number: this.data.driverInfo[0]?.mobile,
      price: this.data.driverRouteInfo?.[0]?.price
        ? Number(this.data.driverRouteInfo[0].price).toFixed(2)
        : '',
      driver_ref_id: this.data.driver_ref_id,
      workorder_id: this.data.workorder_id,
    });
    this.getVehicleList();
  }

  selectChangeHandler(item: any) {}

  public get editFormControl() {
    return this.editTripform.controls;
  }

  getVehicleList() {
    this.services
      .vehicleListEndTrip(this.token, this.data.truck_category, this.data.truck_id)
      .subscribe(
        (response: any) => {
          this.truckArray = response.body;
          this.truckArray.filter((ele: any) => {
            if (ele._id == this.data.truckInfo[0]?._id) {
              this.editTripform.patchValue({
                truck_number: ele._id,
              });
            }
          });
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  public getVehiclesList(item: any) {
    this.selectCatgValue = item.value;
    this.services.GetVehicle(this.selectCatgValue, this.token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.vehiclelists = response.body.data;
          this.selectedDriverId = this.vehiclelists.driverInfo[0]?._id;
          this.editTripform.patchValue({
            driver_number: this.vehiclelists?.driverInfo[0]?.mobile,
            driver_id: this.vehiclelists?.driverInfo[0]?.username,
            truck_ownerNumber: this.vehiclelists?.truckOwnerInfo[0]?.mobile,
            truck_ownerName: this.vehiclelists?.truckOwnerInfo[0]?.username,
          });
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  employeeGet(item: any) {
    this.services
      .getUsersEmployees(
        this.token,
        this.searchEmployeeName,
        this.perPage,
        this.employeeStartPage
      )
      .subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.employeeName = response.body.data;
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  trips(type: any) {
    this.searchtripID = type;
    this.loading = true;
    this.services
      .GetAdminTrips(
        this.token,
        this.startPage,
        this.perPage,
        this.searchQuery,
        this.searchtripID,
        this.tripType
      )
      .subscribe(
        (response: any) => {
          this.loading = false;
          this.tripsArray = response.body.data;
          this.document_array.push(response.body.meta);
          this.last_page = response.body.meta.lastPage;
        },
        (error) => {
          this.tripsArray = [];
          this.loading = false;
          if (error.status == 404) {
            this.paginationTrips = false;
            return;
          }
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");

            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");

            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  public formatFormDate(date: Date | undefined): string {
    if (!date) return ""; // Return empty string if date is undefined
    return formatDate(date, this.dateFormat, this.language);
  }

  UpdateTrips() {
    this.loading = true;
    let trip_start_date = this.editTripform.value.trip_booking_date;
    if (!trip_start_date) {
      this.snackBar.open("Please enter Trip Booking date", "Fail", {
        duration: 5000,
      });
      return;
    }
    let veh_No = this.editTripform.value.truck_number;
    if (!veh_No) {
      this.snackBar.open("Please enter Vehicle no", "Fail", {
        duration: 5000,
      });
      return;
    }
    let price = this.editTripform.value.price;
    if (!price) {
      this.snackBar.open("Please enter valid Price Per Tons", "Fail", {
        duration: 5000,
      });
      return;
    }

    const tripsObj = {
      pickup_date: this.editTripform.value.trip_booking_date,
      truck_id: this.selectCatgValue || this.data.driverInfo[0]?.truck_id,
      driver_id: this.selectedDriverId, //old
      truckowner_id:
        this.vehiclelists?.truckOwnerInfo[0]?._id ||
        this.data.truckInfo[0]?.truckowner_id,
      // workorder_id: this.editTripform.value.workorder_id,
      driver_ref_id: this.editTripform.value.driver_ref_id, //new
      price: Number(this.editTripform.value.price),
    };
    if (tripsObj.price === 0) {
      this.snackBar.open("Price per ton cannot be zero", "Fail", {
        duration: 5000,
      });
      return;
    }
    this.services
      .retailEditTrips(tripsObj, this.token, this.data._id)
      .subscribe(
        (response: any) => {
          if (response.status == 200) {
            this.loading = false;
            this.matdialogref.close();
            this.snackBar.open("Trip details updated successfully", "Success", {
              duration: 5000,
            });
          }
        },
        (error) => {
          this.loading = false;
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  close() {
    this.matdialogref.close();
  }
}
